/*** IMPORTS FROM imports-loader ***/
(function() {

module.exports = global["placeholder"] = require("-!./placeholder.js");
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./_common/_js/placeholder/placeholder.js
// module id = 152
// module chunks = 0